import React from 'react'

import Input from 'Components/Input'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default React.memo(props => <Title inline={props.inline} style={{padding: '5px 0'}} title={props.title} buttons={
        !props.disabled && <button type="button" onClick={props.onClickSaisieLibreMultipleBool} className="text-success ei-commun_ajouter"
                disabled={props.disabled || false}
                style={{ display: props.disabled && 'none' || 'inline-block', marginLeft: 5 }}/>}>
        {
          (props.data || []).map((data, index) => (

            <Grid key={index} container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
                  alignItems={'center'}>
              <Grid item  style={{ margin: 0, padding: 0, display: props.disabled && 'none' || 'inline-block' }}>
                <button type="button" onClick={() => props.onClickRemoveSaisieLibreMultipleBool(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={props.disabled || false}/>
              </Grid>
              <Grid item xs style={{ margin: 0, padding: 0 }}>
                <Input style={props.style}
                  onChange={(e) => props.onChangeSaisieLibeMultipleBool(e, index)}
                  disabled={props.disabled || false}
                  name={'text'}
                  value={data.text !== undefined ? data.text : ""}
                />
              </Grid>
              <Grid item
                    style={{ margin: 0, padding: 0, display: !props.media_lien && 'none' }}>
                <a className={'ei-crm_public'} target="_blank" rel="noopener noreferrer"
                   href={data.text !== undefined ? data.text : ''}/>
              </Grid>
            </Grid>
          ))
        }
      </Title>)


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/SaisieLibreMultiple.js